var map = {
	"./Logo-1.svg": "79b6",
	"./Logo-10.svg": "fb1d",
	"./Logo-11.svg": "4832",
	"./Logo-12.svg": "47fb",
	"./Logo-13.svg": "8768",
	"./Logo-14.svg": "9b4e",
	"./Logo-15.svg": "4ca4",
	"./Logo-16.svg": "3661",
	"./Logo-17.svg": "35c3",
	"./Logo-18.svg": "5cdb",
	"./Logo-19.svg": "689c",
	"./Logo-2.svg": "03d3",
	"./Logo-20.svg": "bf03",
	"./Logo-3.svg": "99b6",
	"./Logo-4.svg": "fd14",
	"./Logo-5.svg": "ed7a",
	"./Logo-6.svg": "a3af",
	"./Logo-7.svg": "3615",
	"./Logo-8.svg": "cc06",
	"./Logo-9.svg": "8ee6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0c";